import { Renderer, ElementRef } from '@angular/core';

/* istanbul ignore next */
import { UUID } from '../models/UUID.model';

/* istanbul ignore next */
export class IDGenerator {
    constructor() { }

    private getID(): string {
        return UUID.UUID();
    }

    private generate(_renderer: Renderer, elementRef: any, attrId: string, componentName: string, Uuid: string) {
        if (elementRef.children.length === 0) {
            return;
        } else {
            for (let i = 0; i < elementRef.children.length; i++) {
                let element = elementRef.children[i];
                _renderer.setElementAttribute(element, attrId, '_' + componentName + '_' + element.localName + i + '_' + Uuid);
                this.generate(_renderer, element, attrId, componentName, Uuid);
            }
        }
    }

    public generateAttribute(_renderer: Renderer, elementRef: any, attrId: string, attrValue: string) {
        let componentName = attrValue;
        let Uuid = this.getID();
        _renderer.setElementAttribute(elementRef, attrId, '_' + attrValue + '_' + Uuid);
        this.generate(_renderer, elementRef, attrId, componentName, Uuid);
    }
}
